import { CommonModule } from '@angular/common';
import { ErrorHandler, inject, NgModule, provideAppInitializer } from '@angular/core';
import { Router } from '@angular/router';
import { SentryHttpErrorHandlerService } from '@core/services';
import * as Sentry from '@sentry/angular';
import { SentryService } from './services/sentry-service/sentry.service';

@NgModule({
  imports: [CommonModule],
})
export class SentryModule {
  static forRoot() {
    return {
      ngModule: SentryModule,
      providers: [
        {
          provide: ErrorHandler,
          useValue: Sentry.createErrorHandler(),
        },
        {
          provide: Sentry.TraceService,
          deps: [Router],
        },
        provideAppInitializer(() => {
          inject(Sentry.TraceService);
        }),

        SentryHttpErrorHandlerService,
        SentryService,
      ],
    };
  }
}
